import { useMemo } from 'react';
import { BadgeTheme } from '@moda/om';
import { useFeatureFlag } from '@moda/portal-stanchions';

export enum CollectionBadgeType {
  Default,
  Price
}

type Collection = {
  analyticsProperty: string;
  name: string;
  enabled: boolean;
  message: string;
  theme: BadgeTheme;
  type: CollectionBadgeType;
};

export const useCollectionBadges = (collections: (string | null)[], type: CollectionBadgeType) => {
  const COLLECTION_BADGE_CONFIG: Collection[] = [
    {
      analyticsProperty: 'Promo-badge-Fall25',
      name: 'fall25',
      enabled: useFeatureFlag('FALL25', [{ default: false }, { if: true, then: true }]),
      message: '25% Off with FALL25',
      theme: 'dark-fuchsia',
      type: CollectionBadgeType.Price
    },
    {
      analyticsProperty: 'Promo-badge-Treat30',
      name: 'treat30',
      enabled: useFeatureFlag('TREAT30', [{ default: false }, { if: true, then: true }]),
      message: '30% Off with TREAT30',
      theme: 'dark-fuchsia',
      type: CollectionBadgeType.Price
    },
    {
      analyticsProperty: 'Promo-badge-Dress30',
      name: 'dress30',
      enabled: useFeatureFlag('DRESS30', [{ default: false }, { if: true, then: true }]),
      message: '30% Off with DRESS30',
      theme: 'dark-fuchsia',
      type: CollectionBadgeType.Price
    },
    {
      analyticsProperty: 'Promo-badge-Take30',
      name: 'take30',
      enabled: useFeatureFlag('TAKE30', [{ default: false }, { if: true, then: true }]),
      message: '30% Off with TAKE30',
      theme: 'dark-fuchsia',
      type: CollectionBadgeType.Price
    }
  ];

  const collectionsWithLowerCase = useMemo(
    () => collections.map(collection => collection?.toLowerCase()),
    [collections]
  );

  return COLLECTION_BADGE_CONFIG.filter(badge => badge.type === type)
    .filter(badge => badge.enabled)
    .find(badgeCollection => collectionsWithLowerCase.includes(badgeCollection.name));
};
